import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { GlowCard } from '../shared/GlowCard';
import { BookOpenIcon, FlameIcon, EyeOffIcon, HeartIcon, UsersIcon, MessageSquareIcon, SparklesIcon, DownloadIcon } from 'lucide-react';
export function Solucion() {
  const features = [{
    icon: BookOpenIcon,
    text: 'Perfil profundo'
  }, {
    icon: FlameIcon,
    text: 'Energía dominante'
  }, {
    icon: EyeOffIcon,
    text: 'Lado oculto'
  }, {
    icon: HeartIcon,
    text: 'Patrones emocionales'
  }, {
    icon: UsersIcon,
    text: 'Compatibilidad base'
  }, {
    icon: MessageSquareIcon,
    text: 'Frases de identidad'
  }, {
    icon: SparklesIcon,
    text: 'Ritual simbólico'
  }, {
    icon: DownloadIcon,
    text: 'Guía digital descargable'
  }];
  return <section className="py-20 px-6 bg-transparent" data-id="element-187">
      <div className="container mx-auto max-w-5xl" data-id="element-188">
        <AnimatedSection data-id="element-189">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-6" data-id="element-190">
            Entra al Núcleo del Arquetipo.
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-191">
          <p className="text-gray-300 text-lg text-center mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-192">
            Una experiencia digital diseñada para revelar la energía fundamental
            que define tu signo. No predicciones. No generalidades. Solo el
            patrón esencial que vive dentro de ti.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-193">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <AnimatedSection key={index} delay={0.3 + index * 0.05} data-id="element-194">
                <GlowCard className="text-center h-full flex flex-col items-center justify-center p-6" data-id="element-195">
                  <Icon size={32} className="text-gold-primary mb-3" data-id="element-196" />
                  <p className="text-gray-200 text-sm" data-id="element-197">{feature.text}</p>
                </GlowCard>
              </AnimatedSection>;
        })}
        </div>
      </div>
    </section>;
}